import { ICarriers } from "../types";
import NationalContactTable from "./NationalContactTable";
import NSAContactTable from "./NSAContactTable";
import SPLCContactTable from "./SPLCContactTable";
import ContactPerStateTable from "./ContactPerStateTable";
import SourceLinkTable from "./SourceLinkTable";
import {
  ChevronRightIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/solid";
import CloseIconButton from "../../../../components/CloseIconButton";
import EditOutlineButton from "../../../../components/EditOutlineButton";
import { useRecoilState, useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS, FIELDPERMISSIONS } from "../../../PermissionsConstants";
import { carrierData, carrierShowState } from "../atom/atoms";
import { defaultCarrierData } from "../atom/atoms";
import CarrierStateAppointedTable from "./CarrierStateAppointedTable";
import { Disclosure } from "@headlessui/react";
import CarrierMetricsPerStateTable from "./CarrierMetricsPerStateTable";
//import AddButton from "../../../../components/AddButton";
interface ICarrierFullView {
  handleEditButton: (carrierRow: ICarriers) => void;
}
const CarrierFullView = ({
  handleEditButton,
}: ICarrierFullView): JSX.Element => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const editPermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_carrier_edit;
  //const addPermission =PERMISSIONS.permission_carrieragreemnentmgmt_carrier_add;
  const [, setShowState] = useRecoilState(carrierShowState);
  const [carrierRowData, setCarrierRowData] =
    useRecoilState<ICarriers>(carrierData);
  return (
    <div className="relative px-2 text-xs py-2 box-shadow border-quinary border-l-2">
      <div className="flex mx-2 justify-between pb border-secondary border-b-2">
        <div className="flex gap-2 items-center pb-2 ">
          <div>
            <RectangleStackIcon className="text-white bg-blue-500 rounded-md h-8 w-8 p-1" />
          </div>
          <div className="leading-tight">
            <h3 className="text-xs font-medium text-gray-500">Carrier</h3>
            <h1 className="mr-auto font-bold text-primary text-md uppercase">
              {carrierRowData.carrierName}{" "}
              {carrierRowData.masterCarrierDetails?.alias
                ? " - " + carrierRowData.masterCarrierDetails?.alias
                : ""}
            </h1>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="flex items-center gap-2">
            {userPermissions.includes(editPermission) && (
              <EditOutlineButton
                buttonText="Edit"
                onClick={() => {
                  handleEditButton(carrierRowData);
                }}
              />
            )}
          </div>
          <div className="">
            <CloseIconButton
              onClick={() => {
                setShowState(false);
                setCarrierRowData(defaultCarrierData);
              }}
            />
          </div>
        </div>
      </div>
      <div className="text-sm bg-bgDB py-2">
        <div>
          <div className="m-2 bg-white rounded-lg box-shadow">
            <div className="text-quinary font-bold font-sans pt-2 px-6">
              Carrier Information
            </div>
            <div className="text-xs font-medium shadow-md pb-2">
              <div className="grid grid-cols-6 gap-x-5 gap-y-2 mx-6 my-2 justify-between">
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Carrier Name:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.carrierName}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Alias:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.masterCarrierDetails?.alias}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Address:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.masterCarrierDetails?.masterCarrierAddress}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    State:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.states
                      ?.map((x) => `${x.states}`)
                      .join(", ")}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    FEIN:
                  </div>
                  <div className="font-medium "> {carrierRowData.fein}</div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    NAIC:
                  </div>
                  <div className="font-medium "> {carrierRowData.naic}</div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    A.M Best Rating:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.amBestRating ?? ""}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Date of A.M Best Rating:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.dateOfAmBestRating
                      ? new Date(
                          carrierRowData.dateOfAmBestRating
                        ).toLocaleDateString()
                      : ""}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Is Digitized:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData?.isDigitized ? "True" : "False"}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Is Active:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData?.isActive ? "True" : "False"}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Is NSA:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.masterCarrierDetails?.nsa
                      ? "True"
                      : "False"}
                  </div>
                </div>
                <div className="gap-2 items-center text-xs">
                  <div className="text-gray-700 font-normal text-left">
                    Is SPLC:
                  </div>
                  <div className="font-medium ">
                    {carrierRowData.masterCarrierDetails?.splc
                      ? "True"
                      : "False"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="m-2 bg-white rounded-lg box-shadow">
            <Disclosure defaultOpen>
              {({ open }) => (
                <>
                  <Disclosure.Button className="disclosureBtn ml-2">
                    <ChevronRightIcon
                      className={`${
                        open ? "transform rotate-90" : ""
                      } w-5 h-5 text-gray-500`}
                    />
                    <div className="disclosureLabel ml-2">
                      {"Carrier Metrics Per State"}
                    </div>
                  </Disclosure.Button>
                  <Disclosure.Panel className="mx-4 bg-white mb-2 border border-gray-200">
                    {
                      <CarrierMetricsPerStateTable
                        data={carrierRowData.carrierMetricsPerState}
                      />
                    }
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>

          <div className="m-2 bg-white rounded-lg box-shadow">
            <div className="text-quinary font-bold font-sans py-2 px-6">
              Contact Details
            </div>
            <div className="text-xs pb-4 font-medium shadow-md">
              <div className="mx-4 bg-white mb-4 border border-gray-200">
                <div className="px-1 py-2 text-primary  font-bold text text-xs ml-3">
                  National Contact
                </div>
                <NationalContactTable data={carrierRowData.nationalContacts} />
              </div>
              {carrierRowData.masterCarrierDetails?.nsa ? (
                <div className="mx-4 bg-white mb-4 border border-gray-200">
                  <div className="px-1 py-2 text-primary font-bold text-xs ml-3">
                    NSA
                  </div>
                  <NSAContactTable data={carrierRowData.nsaContacts} />
                </div>
              ) : (
                ""
              )}
              {carrierRowData.masterCarrierDetails?.splc ? (
                <div className="mx-4 bg-white mb-4 border border-gray-200">
                  <div className="px-1 py-2 text-primary font-bold text-xs ml-3">
                    SPLC
                  </div>
                  <SPLCContactTable data={carrierRowData.splcContacts} />
                </div>
              ) : (
                ""
              )}
              <div className="mx-4 bg-white mb-4 border border-gray-200 ">
                <div className="px-1 py-2 text-primary font-bold text-xs ml-3">
                  State Appointed
                </div>
                <CarrierStateAppointedTable
                  data={carrierRowData.carrierStateAppointed}
                />
              </div>
              <div className="mx-4 bg-white mb-4 border border-gray-200">
                <div className="px-1 py-2 text-primary font-bold text-xs ml-3">
                  Carrier Contact Per State
                </div>
                <ContactPerStateTable
                  data={carrierRowData.carrierContactPerState}
                />
              </div>
              <div className="mx-4 bg-white mb-4 border border-gray-200">
                <div className="px-1 py-2 text-primary font-bold text-xs ml-3">
                  ATTACHMENTS
                </div>
                <SourceLinkTable data={carrierRowData.carrierFiles} />
              </div>
              <Disclosure defaultOpen>
                {({ open }) => (
                  <>
                    <div className="mx-4 bg-white pb-4 rounded-lg box-shadow">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRightIcon
                          className={`${
                            open ? "transform rotate-90" : ""
                          } text-gray-500 w-5 h-5 `}
                        />
                        <div className="disclosureLabel text-sm ml-2">
                          System Information
                        </div>
                      </Disclosure.Button>

                      <Disclosure.Panel className="text-xs bg-white">
                        <div className="grid grid-cols-1 md:grid-cols-2 mx-6 pb-2 gap-12">
                          <div className="space-y-1 mr-6 mt-1">
                            <div className="grid grid-cols-2 gap-2 items-center text-xs">
                              <div className="text-gray-700 font-normal text-left">
                                Created By:
                              </div>
                              <div className="font-medium ">
                                {" "}
                                {carrierRowData.createdBy}
                              </div>
                            </div>
                          </div>{" "}
                          <div className="grid grid-cols-2 gap-2 items-center text-xs">
                            <div className="text-gray-700 font-normal text-left">
                              Modified By:
                            </div>

                            <div className="font-medium ">
                              {" "}
                              {carrierRowData.updatedBy}
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 mx-6 pb-2 gap-12">
                          <div className="space-y-1 mr-6 mt-1">
                            <div className="grid grid-cols-2 gap-2 items-center text-xs">
                              <div className="text-gray-700 font-normal text-left">
                                Created Date:
                              </div>
                              <div className="font-medium">
                                {carrierRowData.createdOn &&
                                  new Date(
                                    carrierRowData.createdOn
                                  ).toLocaleDateString() +
                                    " " +
                                    new Date(
                                      carrierRowData.createdOn
                                    ).toLocaleTimeString(navigator.language, {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-2 items-center text-xs">
                            <div className="text-gray-700 font-normal text-left">
                              Modified Date:
                            </div>
                            <div className="font-medium">
                              {/* {carrierRowData.updatedOn &&
                      new Date(carrierRowData.updatedOn).toLocaleDateString() +
                        " " +
                        new Date(carrierRowData.updatedOn).toLocaleTimeString(
                          navigator.language,
                          { hour: "2-digit", minute: "2-digit" }
                        )} */}
                              {carrierRowData.updatedOn &&
                                new Date(
                                  carrierRowData.updatedOn
                                ).toLocaleDateString() +
                                  " " +
                                  new Date(
                                    carrierRowData.updatedOn
                                  ).toLocaleTimeString(navigator.language, {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                            </div>
                          </div>
                        </div>
                      </Disclosure.Panel>
                    </div>
                  </>
                )}
              </Disclosure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarrierFullView;
